// extracted by mini-css-extract-plugin
export default {"ourRecentWorkContainer":"OurRecentWork_ourRecentWorkContainer__0Y1uT","ourRecentWork":"OurRecentWork_ourRecentWork__qoYuw","recentWorkCard":"OurRecentWork_recentWorkCard__yJTFF"};